/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const hierarchyScopeSchema = z.object({
  levelItemTypeIds: z
    .array(z.int())
    .describe(
      'Item type ids across the root level and the next HIERARCHY_DEPTH - 1 levels below it',
    ),
  rootItemTypeIds: z
    .array(z.int())
    .describe('Item type ids at the shallowest hierarchy level actually populated in this loop'),
});
